import type { Player } from './game.ts';

export type HeartKind='red'|'black'|'piece';
// Small, shared pixel icons keep health pickups and the HUD visually identical.
const shape=[
  '...####..####...',
  '..#rrrr##rrrr#..',
  '.#rrrrrrrrrrrr#.',
  '.#rrrrrrrrrrrr#.',
  '.#rrrrrrrrrrrr#.',
  '..#rrrrrrrrrr#..',
  '...#rrrrrrrr#...',
  '....#rrrrrr#....',
  '.....#rrrr#.....',
  '......#rr#......',
  '.......##.......',
];
const sprites=new Map<string,HTMLCanvasElement>();
export function heartSprite(kind:HeartKind,fill=1):HTMLCanvasElement{
  fill=Math.round(Math.max(0,Math.min(1,fill))*1000)/1000;
  const key=`${kind}:${fill}`,cached=sprites.get(key);if(cached)return cached;
  const canvas=document.createElement('canvas');canvas.width=16;canvas.height=14;
  const ctx=canvas.getContext('2d')!;
  const palette=kind==='red'?['#632d39','#ed696e','#b6374e','#ffc2aa','#32212b']:
    kind==='black'?['#b4a0d0','#282432','#17141f','#776486','#19151e']:
    ['#e6bf70','#ffd889','#d99a48','#fff2ba','#35332c'];
  shape.forEach((row,y)=>[...row].forEach((pixel,x)=>{
    if(pixel==='.')return;
    const quadrant=(y<5?0:2)+(x<8?0:1);
    const filled=kind==='piece'?quadrant<Math.round(fill*4):x<1+fill*14;
    ctx.fillStyle=pixel==='#'?(kind==='black'&&!filled?'#514655':palette[0]!):!filled?palette[4]!:y>5?palette[2]!:palette[1]!;
    if(pixel==='r'&&filled&&x>=3&&x<=5&&y>=2&&y<=3)ctx.fillStyle=palette[3]!;
    if(kind==='piece'&&pixel==='r'&&(x===7||x===8||y===5))ctx.fillStyle=palette[0]!;
    ctx.fillRect(x,y+1,1,1);
  }));
  sprites.set(key,canvas);return canvas;
}
function icon(kind:HeartKind,fill:number){
  const img=document.createElement('img');img.src=heartSprite(kind,fill).toDataURL();img.className=`heart-icon ${kind}`;img.alt='';img.setAttribute('aria-hidden','true');img.dataset.fill=String(fill);return img;
}
export function renderHealthHud(p:Player){
  const hearts=document.getElementById('hearts')!,pieces=document.getElementById('heart-pieces')!;
  const key=`${p.id}:${p.hp}:${p.maxHp}:${p.blackHearts}:${p.heartPieces}`;
  if(hearts.dataset.health===key)return;hearts.dataset.health=key;
  const icons:HTMLImageElement[]=[];
  for(let i=0;i<p.maxHp;i++)icons.push(icon('red',Math.max(0,Math.min(1,p.hp-i))));
  for(let i=0;i<Math.ceil(p.blackHearts);i++)icons.push(icon('black',Math.min(1,p.blackHearts-i)));
  hearts.replaceChildren(...icons);
  hearts.setAttribute('aria-label',`${Number(p.hp.toFixed(1))} cuori su ${p.maxHp}; ${p.blackHearts} cuori neri`);
  const count=document.createElement('span');count.textContent=`${p.heartPieces}/4`;
  pieces.replaceChildren(icon('piece',p.heartPieces/4),count);
  pieces.setAttribute('aria-label',`Frammenti di cuore: ${p.heartPieces} su 4`);
}
